import { FormEvent, useEffect, useState } from "react";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import TextField from "@mui/material/TextField";
import { Button } from "@mui/material";

import Back from "../utils/Back";
import LOGO from "../../semiauth.logo.png";
import Spinner from "../utils/Spinner";
import { useAuth } from "./AuthProvider";
import { useVaultForgotPassword } from "../../hooks/vault/base";

const ForgotPassword = () => {
  const auth = useAuth();

  const [email, setEmail] = useState(auth.user.email);

  const forgot = useVaultForgotPassword();

  const handlePasswordReset = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    // attempt password recovery
    forgot.mutate(email);
  };

  useEffect(() => {
    document.title = "[semiauth] | forgot password";
  }, []); // run once on mount

  return (
    <Container
      component="main"
      maxWidth="sm"
      sx={{
        display: "flex",
        textAlign: "center",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        marginBlock: "auto",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <img src={LOGO} alt="[semiauth] logo" className="logo" />

        <Box component="form" onSubmit={handlePasswordReset} noValidate>
          <TextField
            margin="normal"
            required
            disabled
            fullWidth
            id="email"
            type="email"
            name="email"
            label="Email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <Button
            fullWidth
            type="submit"
            variant="contained"
            disabled={!email}
            sx={{ mt: 3, mb: 2 }}
          >
            {forgot.isPending ? <Spinner sx={{ mx: 7 }} /> : "SEND RESET LINK"}
          </Button>

          <Grid container justifyContent="flex-start">
            <Grid item>
              <Back />
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Container>
  );
};

export default ForgotPassword;
